import React, { useEffect, useState } from 'react';
import moment from "moment";
import Pagination from '../Datatable/Pagination';
import {
    caseStatusInitialPagination,
} from "../../App.config";
import DisplayEmployeeName from "../../containers/DisplayEmployeeName";
import CustomDatePicker from "../../containers/Common/CustomDatePicker";
import * as utilities from "../../utilities/utils";

const MyApplications = (props) => {
    const [currentPage, setCurrentPage] = useState(caseStatusInitialPagination.pageNo);
    const [pageSize, setPageSize] = useState(caseStatusInitialPagination.pageSize);
    const [totalRows, setTotalRows] = useState(caseStatusInitialPagination.totalRows);
    const [serchvalue, setSerchvalue] = useState(null);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [selectedAuthUserId, setSelectedAuthUserId] = useState(null);
    const [selectedTerminationStatus, setSelectedTerminationStatus] = useState(null);
    const [isDateSearchEnable, setIsDateSearchEnable] = useState(false);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);


    useEffect(() => {
        props.getMyApplication();
    }, [])

    useEffect(() => {
        setTotalRows(props.totalCount);
    }, [props.totalCount])

    const onChange = (event) => {
        setCurrentPage(event.target.value);
        props.getMyApplication(event.target.value, pageSize, serchvalue, fromDate, toDate);
    }

    const onChangeSerachValue = (event) => {
        setCurrentPage(1);
        setSerchvalue(event.target.value);
        props.getMyApplication(currentPage, pageSize, event.target.value);
    }

    const searchByDate = (e) => {
        setFromDate(null);
        setToDate(null);
        if (e.target.value)
            setIsDateSearchEnable(true);
        else {
            setIsDateSearchEnable(false);
            props.getMyApplication();
        }
    }

    return (
        <>
            <>
                <>
                    <div className="Card-panel">
                        <div className="Table-list">
                            <DisplayEmployeeName context={props.context} />

                            <div className="row">
                                {<><div className="col-md-4 mb-3">
                                    <div className="form-outline">
                                        <label>{props.context.t(
                                            "MyApplication.Page.Input.SearchByDate"
                                        )}
                                        </label>
                                        <select className="form-control" onChange={searchByDate}>
                                            <option value="">-:{props.context.t(
                                                "MyApplication.Page.Input.SearchByDate.SelectOption"
                                            )}:-</option>
                                            <option value="Date Generated">Date Generated</option>
                                            {/* <option value="Processed Date">Processed Date</option> */}
                                        </select>
                                    </div>
                                </div>
                                    {!isDateSearchEnable && <div className="col-md-4 mb-3 mt-30">
                                        <div className="form-outline">
                                            <label>{props.context.t(
                                                "MyApplication.Page.Input.SearchInputLabel"
                                            )}</label>
                                            <input id="search-input" type="search" className="form-control"
                                                placeholder={props.context.t("MyApplication.Page.Input.Search.Placeholder")}
                                                onChange={onChangeSerachValue}
                                            />
                                        </div>
                                    </div>}
                                    {isDateSearchEnable && <div className="col-md-3 mb-3">
                                        <div className="form-outline">
                                            <label>{props.context.t(
                                                "MyApplication.Page.Input.FromDate"
                                            )}</label>
                                            <CustomDatePicker
                                                id="fromDate"
                                                selected={fromDate}
                                                // selected={state.dateOfAccident.value && state.dateOfAccident.value}
                                                onChange={(fromdate) => {
                                                    // onDateChange(e, "dateOfAccident");
                                                    setFromDate(fromdate);
                                                    if (!fromdate)
                                                        setToDate(null);
                                                    if (toDate) {
                                                        setCurrentPage(1);
                                                        props.getMyApplication(1, pageSize, "", fromdate, toDate);
                                                    }
                                                }}
                                                maxDate={moment().toDate()}
                                                className="form-control"
                                                placeholderText={props.context.t(
                                                    "MyApplication.Page.Input.FromDate"
                                                )}
                                            // ref={state.dateOfAccident.ref}
                                            />
                                        </div>
                                    </div>}
                                    {fromDate && isDateSearchEnable &&
                                        <>
                                            <div className="col-md-3 mb-3">
                                                <div className="form-outline">
                                                    <label>{props.context.t(
                                                        "MyApplication.Page.Input.ToDate"
                                                    )}</label>
                                                    <CustomDatePicker
                                                        id="toDate"
                                                        selected={toDate}
                                                        // selected={state.dateOfAccident.value && state.dateOfAccident.value}
                                                        onChange={(todate) => {
                                                            // onDateChange(e, "dateOfAccident");
                                                            setToDate(todate);
                                                            if (todate) {
                                                                setCurrentPage(1);
                                                                props.getMyApplication(1, pageSize, "", fromDate, todate)
                                                            }
                                                        }}
                                                        maxDate={moment().toDate()}
                                                        minDate={fromDate}
                                                        className="form-control"
                                                        placeholderText={props.context.t(
                                                            "MyApplication.Page.Input.ToDate"
                                                        )}
                                                    // ref={state.dateOfAccident.ref}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-2 mb-3 mt-31">
                                                <button onClick={() => { props.downloadReport(fromDate, toDate) }} className='btn btn-primary'>Download</button>
                                            </div>
                                        </>
                                    }
                                </>
                                }
                            </div>
                            <div className="Table-cell table-responsive pl-1">
                                <table className="table table-bordered">
                                    <thead className="text-center">
                                        {/* <tr><th colSpan="9" className="text-center">Admin Users</th></tr> */}
                                        <tr>
                                            <th>{props.context.t("MyApplication.Page.Table.Header.EmployeeName")}</th>
                                            {/* <th>EIN</th> */}
                                            <th>{props.context.t("MyApplication.Page.Table.Header.ApplicationNumber")}</th>
                                            <th>{props.context.t("MyApplication.Page.Table.Header.GeneratedDate")}</th>
                                            <th>{props.context.t("MyApplication.Page.Table.Header.Status")}</th>
                                            <th>{props.context.t("MyApplication.Page.Table.Header.ApplicationType")}</th>
                                            {/* <th colSpan="4">Action</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {props.myApplications && Array.isArray(props.myApplications) ? props.myApplications.map((application) => (
                                            <tr key={application.applicationId}>
                                                <td className='text-center'>{application.firstName + " " + application.lastName}</td>
                                                {/* <td>{application.ein}</td> */}
                                                <td className='text-center'>{application.applicationUniqueNumber ? application.applicationUniqueNumber : "-"}</td>
                                                <td className='text-center'>{application.applicationDate ? utilities.formatDate(application.applicationDate, "MMM DD YYYY") + " " + new Date('1970-01-01T' + application.applicationDate.toString().split("T")[1] + 'Z')
                                                    .toLocaleTimeString('en-US',
                                                        { timeZone: 'UTC', hour12: true, hour: 'numeric', minute: 'numeric' }
                                                    ).split(" ")[0] + (parseInt(application.applicationDate.toString().split("T")[1].split(":")[0]) < 12 ? "AM" : "PM") : "-"}</td>

                                                <td className='text-center'>{application.dateEntered ? props.context.t("MyApplication.Page.Status.Processed") + " - " +
                                                    utilities.formatDate(application.dateEntered, "MMM DD YYYY") : props.context.t("MyApplication.Page.Status.Pending")}</td>
                                                <td className='text-center'>{application.applicationType}</td>
                                            </tr>
                                        )) :
                                            <tr><td colSpan="6" className="text-center">No data found</td></tr>}
                                    </tbody>
                                </table>
                            </div>
                            {props.myApplications && Array.isArray(props.myApplications) && props.myApplications.length > 0 &&
                                <Pagination
                                    currentPage={currentPage}
                                    pageSize={pageSize}
                                    totalRows={totalRows}
                                    onClickPre={(pageNo) => {
                                        onChange({
                                            target: {
                                                name: "currentPage",
                                                value: pageNo
                                            }
                                        })
                                    }}
                                    onClickNext={(pageNo) => {
                                        onChange({
                                            target: {
                                                name: "currentPage",
                                                value: pageNo
                                            }
                                        })
                                    }}
                                    onClickPage={(pageNo) => {
                                        onChange({
                                            target: {
                                                name: "currentPage",
                                                value: pageNo
                                            }
                                        })
                                    }}
                                ></Pagination>}

                        </div>
                    </div>
                </>
            </>
        </>
    )
}

export default MyApplications;